import { useNavigate } from "react-router-dom";
import { DISABLE_USER_BULK } from "../../apiEndpoints";
import usePostData from "../../../../CustomHooks/useAxios/usePostData";
import Modal from "../../../../components/portal/Modal";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import successIcon from "../../../../assets/icons/successIcon.svg";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";

function BulkUserDisableDialog({ userIDs, closeDialog }) {
  const { executePost, loading, successResponse, formError, setFormError } =
    usePostData();

  const navigate = useNavigate();
  const selectedCount = userIDs.length;

  // Disable user API call
  const handleDisableUser = () => {
    const userIDsData = { user_id_list: userIDs };
    executePost(userIDsData, DISABLE_USER_BULK, () => {});
  };

  const getDisableMessage =
    selectedCount > 1
      ? `Are you sure you want to disable ${selectedCount} users?`
      : "Are you sure you want to disable this user?";

  const getSuccessMessage =
    selectedCount > 1
      ? `${selectedCount} users successfully disabled.`
      : "User successfully disabled.";

  return (
    <>
      <Modal
        onClose={successResponse || loading ? undefined : closeDialog}
        modalWidth={`${
          successResponse ? "max-w-sm" : "max-w-lg"
        } w-11/12 max-sm:w-[95%] max-md:p-4 pb-8 pt-7 px-8`}
      >
        <>
          {successResponse ? (
            <div className="text-center">
              <img
                src={successIcon}
                alt="success"
                className="mx-auto w-9 mb-2"
              />
              <p className="py-5">{getSuccessMessage}</p>
              <GradientButton
                btnText="Ok"
                width="w-26"
                onClick={() => navigate("/user/disable-list")}
              />
            </div>
          ) : (
            <>
              {formError && (
                <ErrorDisplay
                  message={formError}
                  closeAction={() => setFormError("")}
                />
              )}
              <h2 className="text-xl font-figtreeBold mb-4">
                {selectedCount > 1 ? "Disable Users" : "Disable User"}
              </h2>
              <p className="text-gray-700 mb-6">
                {getDisableMessage}
                <br />
                This action will prevent{" "}
                {selectedCount === 1 ? "this user" : "these users"} from
                accessing the system.
              </p>

              {/* Buttons */}
              <div className="flex justify-end gap-3">
                <button
                  onClick={closeDialog}
                  className="px-4 py-2 rounded-lg border bg-dBlue-100 hover:bg-gray-200 text-dark-blue"
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDisableUser}
                  className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
                  disabled={loading}
                >
                  {loading ? "Disabling..." : "Disable"}
                </button>
              </div>
            </>
          )}
        </>
      </Modal>
    </>
  );
}

export default BulkUserDisableDialog;
